import { ConsentFormSettingsComponent } from "src/app/group/components/consent-form-settings/consent-form-settings.component";
import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSection, TutorialSlide } from "../../tutorial.models";

export const CONSENT_SETTINGS_SLIDES: TutorialSlide[] = [
    {
        key: 'Consent-Welcome',
        title: 'Consent Settings! 👋',
        messages: [{ text: "Consent is at the heart of everything we do as healthcare professionals. We need it to store patient information, share that information with colleagues, and carry out any procedures. This process can often be cumbersome and stressful for healthcare practices. MedicAI can automate this process and help alleviate the stress." }],
        actions: [
            {
                text: 'Get Started',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.CUSTOM_CONSENT_FORM, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.DEFAULT_USER_CONSENT_FORM, type: SlideHideConditionType.AND },
        ],
    },
    {
        key: 'Onboarding',
        title: 'Patient Onboarding Consent Forms',
        messages: [
            { text: "These are a set of separate consent documents sent to every patient invited to join your practice via MedicAI. Patients can sign these forms electronically, and their signed consent will be reflected in their MedicAI patient file. This helps you stay compliant with patient data storage and handling regulations like POPIA and also provides a platform for your patients to sign your billing policy." },
        ],
        expansionTarget: 'ONBOARDING_CONSENT_FORM',
        highlightTarget: 'ONBOARDING_CONSENT_FORM',
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DEFAULT_USER_CONSENT_FORM, type: SlideHideConditionType.OR },
        ],
    },
    /* {
        key: 'Practice',
        title: 'Practice Consent Forms',
        messages: [
            { text: "These include your practice's billing policy, which you can edit to fit your specific needs. Please take a moment to review this." },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DEFAULT_USER_CONSENT_FORM, type: SlideHideConditionType.OR },
        ],
    }, */
    {
        key: 'Custom',
        title: 'Procedure Related Consent Forms',
        expansionTarget: 'PROCEDURE_CONSENT_FORM',
        highlightTarget: 'PROCEDURE_CONSENT_FORM',
        //forceOpenTarget: true,
        messages: [
            { text: "These let you add procedure and operation-related consent forms tailored to your practice. There are a few details to keep in mind here, but once set up correctly, your AI Assistant will easily send all your procedure-related consents to patients, who can sign them electronically. These signed forms will also automatically be stored in the patient's file — let's break this down a bit more!" },
            // { text: "To create a custom consent form click the + button", class: 'primary' },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.CUSTOM_CONSENT_FORM, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Consent-Form-Details-1',
        title: 'Consent Form Details',
        //keepDialogOpen: true,
        messages: [
            { text: "Click on the video above to learn how to add Procedure related consent forms!" },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        videoUrl: 'https://www.youtube.com/watch?v=Z4ET_L6iTHA',
        thumbnailUrl: 'assets/consent-form-thumbnail.png',
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.CUSTOM_CONSENT_FORM, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Consent-Finish',
        title: 'Completed Consent Settings!',
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        dimensions: { width: '450px' },
        messages: [{ text: "You are 75% done!" }],
        actions: [
            {
                text: 'Carry on - Recommended',
                color: 'primary',
                actionName: SlideAction.START_CODING_TUTORIAL,
            },
            {
                text: 'Continue Later',
                color: 'warn',
                actionName: SlideAction.CLOSE_TUTORIAL,
                suffixText: 'Continue Later'
            },

        ],
        position: { x: 700, y: 350 },
        hideDoNotShowAgain: true,
        progressBar: 75,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.CUSTOM_CONSENT_FORM, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.DEFAULT_USER_CONSENT_FORM, type: SlideHideConditionType.AND },
        ],
    },
];